const TEST_BUILDER_CONSTANTS = {
  CONTENT_SOURCE: 'LOR',
  PLATFORM: 'CBA',
  ACTION_CODES: {
    SAVE_PROGRESS_COPY: 'saveProgressCopy',
    PUBLISH_OBJECT: 'publishObject'
  },
  RESOURCE_TYPES: {
    WORD_PACKAGE: 'Word package',
    QUAD_ASSESSMENT: 'Quad Assessment'
  },
  STATUSES: {
    SUCCESS: 'SUCCESS',
    INPROGRESS: 'INPROGRESS',
    ERROR: 'ERROR',
    DELETED: 'DELETED'
  }
};

const getAdaptedTestStatus = ({ status = '', actionCode = '' }) => {
  if (
    status === TEST_BUILDER_CONSTANTS.STATUSES.SUCCESS &&
    actionCode === TEST_BUILDER_CONSTANTS.ACTION_CODES.SAVE_PROGRESS_COPY
  ) {
    return TEST_BUILDER_CONSTANTS.STATUSES.INPROGRESS;
  }

  return status;
};

module.exports = {
  TEST_BUILDER_CONSTANTS,
  getAdaptedTestStatus
};
